import state from './moduleKpuState.js'
import mutations from './moduleKpuMutations.js'
import actions from './moduleKpuActions.js'
import getters from './moduleKpuGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

